import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"
import Markdown from "react-markdown"
import * as styles from "./banner.module.scss"
import bannerArtwork from "../../assets/home/banner-artwork.svg"
import awardLogo from "../../assets/awards/women-logo-light.png"

const HomeBanner = props => {
  return (
    <div className={styles.banner}>
      <Container>
        <div
          className={`${styles.banner__wrap} d-flex align-items-center justify-content-between`}
        >
          <div className={styles.banner__content}>
            <h2>{props.data.SubHeading}</h2>
            <h1>{props.data.Heading}</h1>
            <div className={styles.banner__content__summary}>
              <Markdown>{props.data.Summary}</Markdown>
            </div>
            <div className={`d-flex align-items-center`}>
              <a
                target="_blank"
                href={props.data.ButtonLink}
                className="button-slide cta"
              >
                {props.data.ButtonText}
              </a>
              <img src={awardLogo} width="125px" alt="Womens Who Achieves Award Logo" />
            </div>
          </div>
          <div className={styles.banner__artwork}>
            <img src={bannerArtwork} alt="Health Banner Image" />
          </div>
        </div>
      </Container>
    </div>
  )
}

export default HomeBanner
